import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const AdminIcon = (properties: iconType) => (
  <SvgIcon
    {...properties}
    viewBox="0 0 32 30"
    style={{
      fill: 'none',
      width: '23px',
      height: '23px',
      strokeWidth: '.1rem',
    }}
  >
    <rect x="0.5" y="0.5" width="30" height="28" rx="2.5" />
    <path d="M9.35156 5.58984V13.5898" />
    <circle cx="9.35237" cy="17.8231" r="4.20588" />
    <path d="M20.6484 22.5312L20.6484 14.5312" />
    <circle cx="20.6476" cy="10.2941" r="4.20588" transform="rotate(-180 20.6476 10.2941)" />
  </SvgIcon>
);

export default AdminIcon;
